import React from 'react';
import '../styles/BihaniSection.css';
import logo1 from "../assets/Sd law clg logo.png";
import logo2 from "../assets/logoGL.webp";
import logo3 from "../assets/bcalogo.webp";
import logo4 from "../assets/pharmacyLogo.webp";
import logo5 from "../assets/bedlogo.webp";

const colleges = [
  {
    id: 1,
    img: logo1,
    fallback: 'https://placehold.co/110x110/008374/white?text=College+1',
    name: 'SETH.G.L BIHANI SD LAW (P.G) COLLEGE',
    alt: 'Law College',
  },
  {
    id: 2,
    img: logo2,
    fallback: 'https://placehold.co/110x110/008374/white?text=Law+College',
    name: 'SETH G.L. BIHANI S.D. (P.G.) COLLEGE',
    alt: 'PG College',
  },
  {
    id: 3,
    img: logo3,
    fallback: null,
    name: 'BIHANI CHILDRENS ACADEMY',
    alt: 'BCA',
  },
  {
    id: 4,
    img: logo4,
    fallback: null,
    name: 'SETH G.L. BIHANI S.D. COLLEGE OF TECHNICAL EDUCATION',
    alt: 'Technical Education',
  },
  {
    id: 5,
    img: logo5,
    fallback: null,
    name: "SETH. SUSHIL KUMAR BIHANI S.D SHIKSHA MAHAVIDHYALAYA",
    alt: 'Bed College',
  },
];

// Duplicate colleges for seamless loop
const marqueeItems = [...colleges, ...colleges];

function LogoCard({ college }) {
  const handleError = (e) => {
    if (college.fallback) {
      e.target.src = college.fallback;
    }
  };

  return (
    <div className="logo-card">
      <img
        src={college.img}
        alt={college.alt}
        onError={handleError}
      />
      <div className="college-name">
        {college.name.split('\n').map((line, i) => (
          <React.Fragment key={i}>
            {line}
            {i < college.name.split('\n').length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default function BihaniSection() {
  return (
    <div className="bihani-wrapper">
      <div className="bihani-section">

        {/* Heading */}
        <div className="heading-wrap">
          <h1 className="bihani-title">
            BIHANI SHIKSHAN <span>SANSTHAN</span>
          </h1>
          <div className="divider">
            <div className="divider-line"></div>
            <div className="divider-diamond"></div>
            <div className="divider-line gold"></div>
          </div>
        </div>

        {/* Marquee */}
        <div className="marquee-outer">
          <div className="marquee-track">
            {marqueeItems.map((college, index) => (
              <LogoCard key={`${college.id}-${index}`} college={college} />
            ))}
          </div>
        </div>

       

      </div>
    </div>
  );
}